import type { BillingAccountResponse } from '../../repositories';
import { getCurrencySymbol } from '../get-currency-symbol';

enum BillingSystemVersion {
  /** Final major version of billing system using in-house BaaS. */
  BAAS_FINAL = 3,
  /** Initial 2025 implementation of Stripe-based billing system. */
  STRIPE = 4,
}

export class BillingAccount {
  private readonly fallbackCurrency = 'USD';

  constructor(private apiResponse: BillingAccountResponse) {}

  getAriaAccountId(): number {
    return this.apiResponse.ariaAccountId ?? -1;
  }

  getBillingCurrencyId(): number {
    return this.apiResponse.billingCurrencyId ?? -1;
  }

  getBillingDayOfMonth(): number {
    return this.apiResponse.billingDayOfMonth ?? -1;
  }

  getBillingSystemVersion(): number {
    return this.apiResponse.billingSystemVersion ?? -1;
  }

  getIsStripeAccount(): boolean {
    return this.getBillingSystemVersion() >= BillingSystemVersion.STRIPE;
  }

  getCurrency(): string {
    return this.apiResponse.currency || this.fallbackCurrency;
  }

  getCustomerId(): number {
    return this.apiResponse.customerId ?? -1;
  }

  getLanguageTag(): string {
    return this.apiResponse.languageTag ?? '';
  }

  getNoPrepayAutoRenewOptin(): number {
    return this.apiResponse.noPrepayAutoRenewOptin ?? -1;
  }

  getCurrencySymbol = (): string => getCurrencySymbol(this.getCurrency());
}
